// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__17Axk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__228F1","obliqueLine":"membershipbadge_obliqueLine__13_C4"};